export default "__VITE_ASSET__FGlEsMKo__"